import {HTTP} from '../http-common';
import {UTILS} from '../http-common';
import discovery from '../discovery';
import gwt from './gwt';

export default {
    getCommonHeaders()
    {
        var headers = {};

        headers = {
            'authorization': 'Bearer ' + window.kc_token
        };

        let kioskEmployeeId = window.localStorage.getItem('worktime.kiosk.employee.id');
		if (kioskEmployeeId) {
            headers["X-KIOSK-EMPLOYEE"] = kioskEmployeeId;
            headers["X-DEVICE-TYPE"] = 'KIOSKO';
        } else {
            headers["X-DEVICE-TYPE"] = gwt.isApp() ? 'APP' : 'WEB';
        }
 
        ///////////////////////////////////////////////////////////////
        // FIX multiples perfiles

        let clientCompany = window.localStorage.getItem('worktime.client.company.id');
        if (clientCompany) {
            headers['x-client-company'] = clientCompany;
        }

        ///////////////////////////////////////////////////////////////

        if (/MSIE|Trident/.test(window.navigator.userAgent))
        {
            headers['Pragma'] = 'no-cache';
            headers['Cache-Control'] = 'no-cache, no-store';
        }

        return { headers: headers };
    },
    genericGet(service,cbok, cberr)
    {
        HTTP
            .get(discovery.worktime_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPut (service,data,cbok, cberr)
    {
        HTTP
            .put(discovery.worktime_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                if (cbok)
                    cbok(response.data);
            }).catch(function (error) {
                if (cberr)
                    cberr(error);
            });
    },
    genericPost(service,data,cbok, cberr)
    {
        HTTP
            .post(discovery.worktime_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericDelete(service,cbok, cberr)
    {
        HTTP
            .delete(discovery.worktime_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    getContextValue(key)
    {
        return window.tweemContext ? window.tweemContext[key]:'';
    },
    /////////////////////////////////////////////////////////////////
    //COMMON 
    
		getStaff (cbok, cberr)
    {
        this.genericGet('admin/staff', cbok, cberr);
    },
    executeQuery (data, cbok, cberr)
    {
        this.genericPost('analytics/executeQuery', data, cbok, cberr);
    },
		getCompanies (cbok, cberr)
    {
        this.genericGet('admin/companies', cbok, cberr);
    },
    getWorkplacesByCompanyId(companyId, cbok, cberr)
		{
        this.genericGet('admin/workplaces-by-company-id/'+ companyId, cbok, cberr);
    },

     /////////////////////////////////////////////////////////////////
    /*/Dialog manager
    getDialog (id, cbok, cberr)
    {
        this.genericGet('dialog/'+id, cbok, cberr);
    },    
    deleteDialog (id, cbok, cberr)
    {
        this.genericDelete('dialog/'+id, cbok, cberr);
    },   
    storeDialog(module, cbok, cberr)
    {
        this.genericPost('dialog/', module, cbok, cberr);
    },    
    getDialogs (cbok, cberr)
    {
        this.genericGet('dialog/config', cbok, cberr);
    }, */

    /////////////////////////////////////////////////////////////////
    //Module manager
    /*getModule (id, cbok, cberr)
    {
        this.genericGet('module/'+id, cbok, cberr);
    },    
    deleteModule (id, cbok, cberr)
    {
        this.genericDelete('module/'+id, cbok, cberr);
    },   
    storeModule (module, cbok, cberr)
    {
        this.genericPost('module/', module, cbok, cberr);
    },    
    getModules (cbok, cberr)
    {
        this.genericGet('module/config', cbok, cberr);
    }, 
    getModuleData (id, context, cbok, cberr)
    {
        this.genericPost('module/data/' + id, context, cbok, cberr);
    }, */
    /////////////////////////////////////////////////////////////////
    //Export module
    downloadExportCSV(id, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(discovery.worktime_service_url + 'admin/download-export-csv/' + id, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
              });
    },
    getLinkDownloadExportCSV(id, cbok, cberr)
    {   
        HTTP
            .get(discovery.worktime_service_url + 'admin/export-csv-link/' + id, this.getCommonHeaders())
            .then((response) => {
                if (cbok) {
                    let url = discovery.worktime_service_url;
                    url = url.replace('/rest/', '');
                    url = `${url}/${response.data}`;
                    cbok(url);
                }
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
              });
    },    
    deleteExport (id, cbok, cberr)
    {
        this.genericDelete('admin/delete-export/' + id, cbok, cberr);
    },
   /////////////////////////////////////////////////////////////////
    //AUDITLOG
    
    getAuditLog (id, cbok, cberr)
    {
        this.genericGet('admin/audit-log/'+id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //EXPENSE SHEETS

    getExpenseSheets (companyId, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet(`user/expense-sheet/${companyId}/list?sortBy=${sortBy}&sortDesc=${sortDesc}`, cbok, cberr);
    },
    getFullExpenseSheetById (id, cbok, cberr)
    {
        this.genericGet(`user/full-expense-sheet/${id}`, cbok, cberr);
    },
    getExpenseSheetById (id, cbok, cberr)
    {
        this.genericGet(`user/expense-sheet/${id}`, cbok, cberr);
    },
    extractExpenseSheetItemTicketInfo (data, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet-item/ticket-info`, data, cbok, cberr);
    },
    deleteExpenseSheetItemDocument(id, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet-item/${id}/delete-document`, null, cbok, cberr);
    },
    storeExpenseSheet (data, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet`, data, cbok, cberr);
    },
    sendExpenseSheetById (id, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet/${id}/send`, null, cbok, cberr);
    },
    cancelExpenseSheetRequestById (id, cbok, cberr)
    {
        this.genericPost(`user/expense-sheet/${id}/cancel-request`, null, cbok, cberr);
    },
    deleteExpenseSheetById (id, cbok, cberr)
    {
        this.genericDelete(`user/expense-sheet/${id}`, cbok, cberr);
    },
    getExpenseSheetItemsBySheetId (sheetId, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet(`user/expense-sheet-item/${sheetId}/list?sortBy=${sortBy}&sortDesc=${sortDesc}`, cbok, cberr);
    },
    downloadExpenseSheetItemDocumentContent (sheetId, sheetItemId, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(`${discovery.worktime_service_url}user/expense-sheet-item/${sheetId}/download/${sheetItemId}`, options)
            .then(async (response) => {
                if (cbok) {
                    const blob = response.data;
                    const buffer = Buffer.from(await blob.arrayBuffer());

                    // Ensure a correct image MIME type for broader compatibility (e.g., Android 12 WebView)
                    let mime = blob.type || '';

                    // Detect image MIME from magic numbers when content-type is missing or generic
                    const detectImageMime = (buf) => {
                        if (!buf || buf.length < 12) return null;
                        // JPEG FF D8 FF
                        if (buf[0] === 0xFF && buf[1] === 0xD8 && buf[2] === 0xFF) return 'image/jpeg';
                        // PNG 89 50 4E 47
                        if (buf[0] === 0x89 && buf[1] === 0x50 && buf[2] === 0x4E && buf[3] === 0x47) return 'image/png';
                        // GIF 47 49 46 38
                        if (buf[0] === 0x47 && buf[1] === 0x49 && buf[2] === 0x46 && buf[3] === 0x38) return 'image/gif';
                        // WEBP RIFF....WEBP
                        if (
                            buf[0] === 0x52 && buf[1] === 0x49 && buf[2] === 0x46 && buf[3] === 0x46 &&
                            buf[8] === 0x57 && buf[9] === 0x45 && buf[10] === 0x42 && buf[11] === 0x50
                        ) return 'image/webp';
                        // HEIC brand inside ftyp box
                        if (
                            buf[4] === 0x66 && buf[5] === 0x74 && buf[6] === 0x79 && buf[7] === 0x70 &&
                            (
                              // heic | heix | hevc | hevx
                              (buf[8] === 0x68 && buf[9] === 0x65 && buf[10] === 0x69 && buf[11] === 0x63) ||
                              (buf[8] === 0x68 && buf[9] === 0x65 && buf[10] === 0x69 && buf[11] === 0x78) ||
                              (buf[8] === 0x68 && buf[9] === 0x65 && buf[10] === 0x76 && buf[11] === 0x63) ||
                              (buf[8] === 0x68 && buf[9] === 0x65 && buf[10] === 0x76 && buf[11] === 0x78)
                            )
                        ) return 'image/heic';
                        return null;
                    };

                    if (!mime || !mime.startsWith('image/')) {
                        const detected = detectImageMime(buffer);
                        if (detected) {
                            mime = detected;
                        }
                    }

                    // Final fallback to a safe default
                    if (!mime || !mime.startsWith('image/')) {
                        mime = 'image/jpeg';
                    }

                    const base64 = 'data:' + mime + ';base64,' + buffer.toString('base64');
                    cbok(base64);
                }
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    downloadExpenseSheetItemDocument (sheetId, sheetItemId, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(`${discovery.worktime_service_url}user/expense-sheet-item/${sheetId}/download/${sheetItemId}`, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    getExpenseSheetCategories (cbok, cberr)
    {
        this.genericGet(`user/expense-sheet-category`, cbok, cberr);
    },
    getExpenseSheetItemById (id, cbok, cberr)
    {
        this.genericGet(`user/expense-sheet-item/${id}`, cbok, cberr);
    },
    storeExpenseSheetItem (data, cbok, cberr) {
        this.genericPost('user/expense-sheet-item', data, cbok, cberr);
    },
    deleteExpenseSheetItemById (id, cbok, cberr)
    {
        this.genericDelete(`user/expense-sheet-item/${id}`, cbok, cberr);
    },

}

